import { useState } from "react";
import { ContactTitle, Main, TitleImage } from "./styles";
import HeaderMobile from "../HeaderMobile";
import profile1 from "../../assets/profile1.png";
import profile2 from "../../assets/profile2.jpeg";
import AboutMeText from "../AboutMeText";
import ProjectsPageMobile from "../../pages/ProjectsPage/projectsPageMobile";
import ContactPage from "../../pages/ContactPage";
import cv from "../../assets/CV-en.pdf";

const MobileApp = () => {
  const [altImg, setAltImg] = useState(false);

  const changeImage = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
    const img = e.target as HTMLImageElement;
    img.classList.add("tran");
    setTimeout(() => setAltImg(!altImg), 150);
    setTimeout(() => {
      img.classList.remove("tran");
    }, 300);
  };

  return (
    <div className="App">
      <HeaderMobile />
      <Main>
        <div className="colored-box">
          <div className="first-section">
            <div className="title-container">
              <h1>Nicholas Engelbert</h1>
              <h6>Software developer</h6>
            </div>

            <TitleImage>
              <img
                onClick={changeImage}
                className="title-img"
                src={altImg ? profile2 : profile1}
                alt=""
              />
            </TitleImage>
            <a
              href={cv}
              target="_blank"
              style={{
                fontFamily: "serif",
                fontSize: "24px",
                textDecoration: "underline",
                marginLeft: "100px",
                marginTop: "40px",
              }}
            >
              CV.
            </a>
          </div>

          <div id="projects" className="title-container">
            <h1>Project showcase:</h1>
          </div>
          <ProjectsPageMobile />

          <div id="aboutme" className="title-container">
            <h1>About me:</h1>
          </div>
          <AboutMeText />
        </div>
      </Main>
      <div id="contact">
        <ContactTitle>
          <h1>Contact me:</h1>
        </ContactTitle>
        <ContactPage />
      </div>
    </div>
  );
};

export default MobileApp;
